document.addEventListener("DOMContentLoaded", () => {
    const filteredCardsContainers =
        document.querySelectorAll(".filtered-cards");

    if (!filteredCardsContainers.length) return;

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    filteredCardsContainers.forEach((filteredCards, index) => {
        const columns = [
            ...filteredCards.querySelectorAll(
                '.flex-cards > [class*="col-"]'
            )
        ];

        const tags1 = new Set();
        const tags2 = new Set();

        // Collect tags and save original parent row
        columns.forEach(col => {
            const cardTags1 = [];
            const cardTags2 = [];

            col.querySelectorAll("p s").forEach(tag => {
                const value = tag.textContent.trim();

                if (!value) return;

                if (tag.closest("strong")) {
                    cardTags2.push(value);
                    tags2.add(value);
                } else {
                    cardTags1.push(value);
                    tags1.add(value);
                }
            });

            col.dataset.tags1 = JSON.stringify(cardTags1);
            col.dataset.tags2 = JSON.stringify(cardTags2);

            col._originalParent = col.parentNode;
        });

        let filterHTML = "";

        // Filter By Category
        if (tags1.size > 0) {
            const filter1Id = `filter-menu-1-${index}`;

            filterHTML += `
                <div class="filter-group">
                    <button
                        type="button"
                        class="filter-toggle filter-toggle-1 form-control"
                        aria-expanded="false"
                        aria-controls="${filter1Id}"
                    >
                        Filter By Category <i class="fa-solid fa-caret-down"></i>
                    </button>

                    <div
                        id="${filter1Id}"
                        class="filter-menu filter-menu-1"
                    >
                        ${[...tags1]
                            .sort()
                            .map(
                                tag => `
                                    <label>
                                        <input type="checkbox" value="${escapeHtml(tag)}">
                                        ${escapeHtml(tag)}
                                    </label>
                                `
                            )
                            .join("")}
                    </div>
                </div>
            `;
        }

        // Filter By Year
        if (tags2.size > 0) {
            const filter2Id = `filter-menu-2-${index}`;

            filterHTML += `
                <div class="filter-group">
                    <button
                        type="button"
                        class="filter-toggle filter-toggle-2 form-control"
                        aria-expanded="false"
                        aria-controls="${filter2Id}"
                    >
                        Filter By Year <i class="fa-solid fa-caret-down"></i>
                    </button>

                    <div
                        id="${filter2Id}"
                        class="filter-menu filter-menu-2"
                    >
                        ${[...tags2]
                            .sort()
                            .map(
                                tag => `
                                    <label>
                                        <input type="checkbox" value="${escapeHtml(tag)}">
                                        ${escapeHtml(tag)}
                                    </label>
                                `
                            )
                            .join("")}
                    </div>
                </div>
            `;
        }

        // Don't create a filter row if no filters exist
        if (!filterHTML.trim()) {
            return;
        }

        const filter = document.createElement("div");
        filter.className =
            "row row-wide card-filter form-inline";
        filter.innerHTML = filterHTML;

        filteredCards.prepend(filter);

        const firstRow =
            filteredCards.querySelector(".flex-cards");

        const resultsGrid =
            firstRow.cloneNode(false);

        resultsGrid.classList.add(
            "filtered-results"
        );
        resultsGrid.innerHTML = "";
        resultsGrid.style.display = "none";

        filter.insertAdjacentElement(
            "afterend",
            resultsGrid
        );

        // Dropdown open/close logic
        filter.querySelectorAll(".filter-toggle").forEach(toggle => {
            toggle.addEventListener("click", e => {
                e.stopPropagation();

                const menu =
                    toggle.nextElementSibling;

                const isOpening =
                    !menu.classList.contains("open");

                // Close sibling menus
                filter.querySelectorAll(".filter-menu").forEach(m => {
                    if (m !== menu) {
                        m.classList.remove("open");

                        const siblingToggle =
                            m.previousElementSibling;

                        if (siblingToggle) {
                            siblingToggle.setAttribute(
                                "aria-expanded",
                                "false"
                            );
                        }
                    }
                });

                // Toggle current menu
                menu.classList.toggle("open", isOpening);

                toggle.setAttribute(
                    "aria-expanded",
                    isOpening ? "true" : "false"
                );
            });
        });

        // Close menus when clicking outside
        document.addEventListener("click", e => {
            if (!filter.contains(e.target)) {
                filter.querySelectorAll(".filter-menu").forEach(menu => {
                    menu.classList.remove("open");

                    const toggle =
                        menu.previousElementSibling;

                    if (toggle) {
                        toggle.setAttribute(
                            "aria-expanded",
                            "false"
                        );
                    }
                });
            }
        });

        function applyFilters() {
            const selectedTags1 = [
                ...filter.querySelectorAll(
                    ".filter-menu-1 input:checked"
                )
            ].map(cb => cb.value);

            const selectedTags2 = [
                ...filter.querySelectorAll(
                    ".filter-menu-2 input:checked"
                )
            ].map(cb => cb.value);

            const originalRows =
                filteredCards.querySelectorAll(
                    ".flex-cards:not(.filtered-results)"
                );

            // Always restore cards first
            columns.forEach(col => {
                col._originalParent.appendChild(col);
            });

            resultsGrid.innerHTML = "";

            const noFiltersApplied =
                selectedTags1.length === 0 &&
                selectedTags2.length === 0;

            if (noFiltersApplied) {
                resultsGrid.style.display = "none";

                originalRows.forEach(row => {
                    row.style.display = "";
                });

                return;
            }

            columns.forEach(col => {
                const cardTags1 = JSON.parse(
                    col.dataset.tags1 || "[]"
                );

                const cardTags2 = JSON.parse(
                    col.dataset.tags2 || "[]"
                );

                const matchesTags1 =
                    selectedTags1.length === 0 ||
                    selectedTags1.every(tag =>
                        cardTags1.includes(tag)
                    );

                const matchesTags2 =
                    selectedTags2.length === 0 ||
                    selectedTags2.every(tag =>
                        cardTags2.includes(tag)
                    );

                if (matchesTags1 && matchesTags2) {
                    resultsGrid.appendChild(col);
                }
            });

            originalRows.forEach(row => {
                row.style.display = "none";
            });

            resultsGrid.style.display = "";
        }

        filter.addEventListener("change", applyFilters);
    });
});